import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'src/assets/js/highcharts';

@Component({
  selector: 'g10-roster-dashboard-summary',
  templateUrl: './roster-dashboard-summary.component.html',
  styleUrls: ['./roster-dashboard-summary.component.css']
})
export class RosterDashboardSummaryComponent implements OnInit {
  //summary screen
  public tableHeaders = [
    'S.No',
    'Vehicle Reg No',
    'Model',
    'Employees',
    'Slot',
    'Status',
  ];
  public tableRows = [
    {
      VehId: '54653',
      RegNo: 'TN01RR1155',
      Model: 'Bus',
      Employees: '2',
      Slot: '06:00',
      Status: 'Dispatched',
    },
    {
      VehId: '64565',
      RegNo: 'TN07CV8223',
      Model: 'Suv',
      Employees: '2',
      Slot: '06:00',
      Status: 'Dispatched',
    },
    {
      VehId: '64545',
      RegNo: 'TN60SA1561',
      Model: 'Sedan',
      Employees: '2',
      Slot: '06:00',
      Status: 'Dispatched',
    },
    {
      VehId: '72456',
      RegNo: 'TN07CV8257',
      Model: 'Sedan',
      Employees: '2',
      Slot: '06:00',
      Status: 'Dispatched',
    },
    {
      VehId: '34567',
      RegNo: 'TN57AA0004',
      Model: 'Suv',
      Employees: '2',
      Slot: '06:00',
      Status: 'Dispatched',
    }
  ];
  public infoData:any=[{
    title: 'Group10 Technologies Pvt Ltd',
    day: 'Tuesday,March 28,2023'
  }]

  constructor() { }

  ngOnInit(): void {
    this.loadVehChart();
    this.loadEmpChart();
  }

  loadEmpChart(){
    Highcharts.chart('employees-container', {
      chart: {
          type: 'area'
      },
      exporting: {
        buttons: {
            contextButton: {
                enabled: false
            }
         }
      },
      title: {
          text: 'Persons Serviced',
          align: 'center'
      },
      tooltip: {
          shared: true,
          headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
      },
      plotOptions: {
          series: {
              pointStart: 0,
          },
          area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                  lineWidth: 1,
                  lineColor: '#666666'
              }
          }
      },  credits: {
        enabled: false
      },
      series: [{
          name: 'Persons',
          data: [8,9,9,8,7,8,9,10,9,9],
          color: 'rgb(98,100,167)'
      }]
  });
  
  }
  loadVehChart(){
    Highcharts.chart('vehicles-container', {
      chart: {
          type: 'area'
      },
      exporting: {
        buttons: {
            contextButton: {
                enabled: false
            }
         }
      },
      title: {
          text: 'Dispatch Trips',
          align: 'center'
      },
      tooltip: {
          shared: true,
          headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
      },
      plotOptions: {
          series: {
              pointStart: 0,
          },
          area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                  lineWidth: 1,
                  lineColor: '#666666'
              }
          }
      },  credits: {
        enabled: false
      },
      series: [{
          name: 'Trips',
          data: [3,4,4,5,4,3,3,4,5,5],
          color: 'rgb(239,163,29)'
      }]
  });
  
  }
}
